import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import DateRangePickerNew from "components/common/DateRangePicker/DateRangePickerNew";
import Header from "components/common/Header/Header";
import SelectOption from "components/common/Select/Select";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useEffect, useState } from "react";


import PaginationComponent from "components/common/Pagination/index";
import {
  emptyPaginationObj,
  REPORTING_LIMIT,
  SORT_TYPE,
  getParticipantLabel,
} from "Constants/constant";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import { apiPostRequest } from "helpers/Requests";
import { URL_REPORTING_INCIDENT_REPORTS } from "store/services/URL";

import _ from "lodash";

import { toast } from "react-toastify";

import { addMonths, exportTOExcel, truncateTextReporting } from "Utils/utils";
import useReportExport from "../useReportExport";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFilterSearchField,
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import { withReportSortOnUrl } from "../reportExportUtils";
import PopoverContainer from "components/common/Popover/PopoverContainer";
import { addWeeks, endOfWeek, startOfWeek } from "date-fns";

const IncidentReports = ({getParticipantList, spParticipants, settings}) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const participantNameLabel = getParticipantLabel(settings?.care_sector, false) + " Name";
  const participantLabel = getParticipantLabel(settings?.care_sector, false);
  const searchByParticipantLabel = `Search by ${participantNameLabel}`;

  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    const filters = {
      page: 1,
      per_page: 500,
      search: null,
    };
    getParticipantList({ filters, bodyFilter: null });
  }, []);

  const [participantList, setParticipant] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState(null);

  const [search, setSearch] = useState(null);

  const [reportList, setReports] = useState(null);
  const [loader, setLoader] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isDisableSearch, setIsDisableSearch] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const { runExport, QueuedModal, getExportSortFilters } = useReportExport(
    "incident_report",
    "Incident Report",
    { sortBy, sortDescending }
  );

  useEffect(() => {
    if (!isInitialRender) {
      fetchListReports(false, null, {
        page,
        sort_field: sortBy,
        sort_order: sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
      });
    }
  }, [page]);

  useEffect(() => {
    const now = new Date();

    const firstDayOfWeek = now.getDate() - now.getDay();

    const lastDayOfWeek = firstDayOfWeek + 6;

    const startOfWeek = new Date(now.setDate(firstDayOfWeek));

    const endOfWeek = new Date(now.setDate(lastDayOfWeek));

    setFromDate(startOfWeek);

    setToDate(endOfWeek);
  }, []);

  useEffect(() => {
    const updateLists = async () => {
      const participants =
        spParticipants?.participant?.data?.map((item) => ({
          label: `${item?.first_name} ${item?.last_name}`,
          value: item?.id,
        })) || [];

      const sortedParticipants = participants.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );

      const allParticipants = [
        { label: "All", value: "all" },
        ...sortedParticipants,
      ];
      setParticipant(allParticipants);

      // Set the default selected participant to "All"
      setSelectedParticipant(allParticipants[0]); // Select "All" by default

      // Fetch reports for "All" participants
      fetchListReports(false, null, {
        page: 1,
        sort_field: sortBy,
        sort_order: sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
      });
    };

    updateLists();
  }, [spParticipants]);

  const fetchListReports = async (
    isClearAll = false,
    report = null,
    filters = {}
  ) => {
    if (!fromDate && !toDate) {
      if (hasMounted) {
        // Check if the component has mounted

        toast("Select schedule shift date range to get data");
      }
      return;
    }
    const currentPage = filters.page || page;
    setLoader(true);
    let url = `${URL_REPORTING_INCIDENT_REPORTS}?per_page=25&page=${currentPage}`;
    url = withReportSortOnUrl(url, filters, sortBy, sortDescending);
    const payload = {
      search: search ? search : "",
      participant: isClearAll
        ? "all"
        : selectedParticipant
        ? selectedParticipant?.value
        : "all",

      date_range_created: isClearAll
        ? "all"
        : toDate && fromDate
        ? [fromDate, toDate]
        : "all",
    };
    if (report) {
      await runExport({
        format: report,
        payload,
        syncUrl: url,
        filters,
        totalRows: paginationObj?.total,
        setLoader,
        onSyncExcel: exportTOExcelFile,
        onSyncPdf: (downloadUrl) => window.open(downloadUrl, "_blank"),
      });
      return;
    }
    await apiPostRequest(url, payload)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          setReports(res?.data?.data);
          setPaginationObj((prev) => ({
            ...prev,
            total: res?.data?.data?.incident_reports?.total,
            totalPages: Math.ceil(
              res?.data?.data?.incident_reports?.total /
                res?.data?.data?.incident_reports?.per_page
            ),
          }));
        }
      })
      .catch((error) => {
        toast.error(`${error}`);
        console.log({ error });
        setLoader(false);
      });
  };

  useEffect(() => {

    setHasMounted(true);

  }, []);

  const handleFileDownLoad = (e) => {
    fetchListReports(false, e, getExportSortFilters());
  };

  const handleSearch = () => {
    setPage(1);

    const updatedPaginationObj = { ...paginationObj, page: 1 };
    setPaginationObj(updatedPaginationObj);

    fetchListReports(false, null, {
      page: 1,
      sort_field: sortBy,
      sort_order: sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  const handleClearFilters = () => {
    setFromDate(null);
    setToDate(null);
    setSearch(null);
    setReports([]);
    setSelectedFromDate(null);
    setSelectedParticipant(null);
  };

  const exportTOExcelFile = (reportData) => {
    const transformedData =
      reportData &&
      reportData.incident_reports &&
      reportData?.incident_reports?.map((item) => {
        return {
          Id: `IN-${item?.id}` || "N/A",
          [participantLabel]: item?.participant_name || "N/A",
          Created_By: item?.created_by || "N/A",
          Incident_Created_Date: item?.created_at || "N/A",
        };
      });
    if (
      !transformedData ||
      transformedData === undefined ||
      transformedData?.length === 0
    ) {
      toast("No data found!");
      return;
    }

    exportTOExcel(transformedData);
  };

  const handleFetch = (obj) => {
    fetchListReports(false, null, { ...obj });
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  const handleDateChange = (obj) => {
    if (obj && obj.fromDate && obj.toDate) {
      const startOfWeek = new Date(obj.fromDate);

      const endOfWeek = new Date(obj.toDate);

      // Adjust to the start of the week (Sunday)

      startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay());

      // Adjust to the end of the week (Saturday)

      endOfWeek.setDate(endOfWeek.getDate() + (6 - endOfWeek.getDay()));

      setFromDate(startOfWeek);

      setToDate(endOfWeek);
    }
  };

  const [maxDate, setMaxDate] = useState(new Date()); // State to hold the max date

  useEffect(() => {
    const now = new Date();

    // Calculate the start and end of the current week

    const startOfCurrentWeek = startOfWeek(now, { weekStartsOn: 0 }); // 0 for Sunday

    const endOfCurrentWeek = endOfWeek(now, { weekStartsOn: 0 }); // 0 for Sunday

    setFromDate(startOfCurrentWeek);

    setToDate(endOfCurrentWeek);

    setMaxDate(endOfCurrentWeek); // Set the max date to the end of the current week
  }, []);
  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='Incident Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.INCIDENT_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
              <ReportFilterGrid columns={4}>
                <ReportFilterField label={participantNameLabel}>
                  <SelectOption
                    newDesign
                    cssClass='w-full'
                    name='pt_id'
                    isSearch={true}
                    data={participantList || []}
                    selectedOption={selectedParticipant}
                    handleChange={(e) => {
                      if (selectedParticipant?.value !== e.value) {
                        setSelectedParticipant(e);
                      }
                    }}
                  />
                </ReportFilterField>
                <ReportFilterField label='Incident created Date range (Weekly only)' required>
                  <DateRangePickerNew
                    handleCancel={() => {
                      setFromDate(null);
                      setToDate(null);
                      setReports([]);
                    }}
                    handleChange={(obj) => {
                      if (obj && obj.fromDate && obj.toDate) {
                        setFromDate(obj.fromDate);
                        setToDate(obj.toDate);
                      }
                    }}
                    setSelectedFromDate={setSelectedFromDate}
                    fromDate={fromDate}
                    toDate={toDate}
                    maxDate={maxDate}
                    setIsDisableSearch={setIsDisableSearch}
                  />
                </ReportFilterField>
                <ReportFilterSearchField
                  label={searchByParticipantLabel}
                  search={search}
                  setSearch={setSearch}
                  onSearch={handleSearch}
                  placeholder={searchByParticipantLabel}
                />
              </ReportFilterGrid>
              <ReportFilterActions
                onSearch={handleSearch}
                onClear={handleClearFilters}
                onExport={handleFileDownLoad}
                isLoading={loader}
                isSearchDisabled={isDisableSearch}
                isUserGracePeriodOver={isUserGracePeriodOver}
              />
            </ReportFiltersShell>
            <ReportTableSection>
                <table className='border min-w-full divide-y divide-gray-300'>
                  <thead
                    // style={{ top: "130px" }}
                    className='bg-gray-50 sticky z-[5]'
                  >
                    <tr>
                      <TableHeader
                        sortName='id'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"ID"}
                        cssClass='bg-blue-50 pl-4'
                      />
                      <TableHeader isSort={false} label={participantNameLabel} cssClass='bg-blue-50' />

                      <TableHeader isSort={false} label={"Created By"} cssClass='bg-blue-50' />

                      <TableHeader
                        sortName='created_at'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Incident Created Date"}
                        cssClass='bg-blue-50'
                      />
                    </tr>
                  </thead>
                  <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
                    {loader ? (
                      <tr className='bg-white'>
                        <td colSpan={4} className='py-6 text-center bg-white'>
                          <div
                            className={`flex flex-col w-full min-h-screen  items-center justify-start`}
                          >
                            <CircularLoader
                              classes='flex justify-center items-center'
                              classloader='loader-l'
                            />
                          </div>
                        </td>
                      </tr>
                    ) : reportList !== null &&
                      reportList?.incident_reports?.data?.length > 0 ? (
                      reportList?.incident_reports?.data?.map((EL, index) => (
                        <tr
                          key={index}
                          className='even:bg-white odd:bg-gray-50'
                        >
                          <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                            {`IN-${EL.id}`}
                          </td>
                          <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                            <div
                              className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                              style={{
                                maxWidth: "100px",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {EL?.participant_name ? (
                                <PopoverContainer
                                  cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                  itemComponent={() => {}}
                                  toolTip={`${EL?.participant_name}`}
                                >
                                  <span>
                                    {truncateTextReporting(
                                      EL?.participant_name
                                    )}
                                  </span>
                                </PopoverContainer>
                              ) : (
                                "-"
                              )}
                            </div>
                          </td>
                          <td className='py-[11px] px-3 text-left  text-sm text-gray-500'>
                            <div
                              className=' font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                              style={{
                                maxWidth: "100px",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {EL?.created_by ? (
                                <PopoverContainer
                                  cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                  itemComponent={() => {}}
                                  toolTip={`${EL?.created_by}`}
                                >
                                  <span>
                                    {truncateTextReporting(EL?.created_by)}
                                  </span>
                                </PopoverContainer>
                              ) : (
                                "-"
                              )}
                            </div>
                          </td>
                          <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                            {EL?.created_at || "N/A"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={4}
                          className='py-6 text-center text-red-600'
                        >
                          No data found. Please adjust your filters to get
                          relevant results
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
            </ReportTableSection>

              {reportList && reportList?.incident_reports?.data?.length > 0 && (
                <div className='mt-3'>
                  <PaginationComponent
                    page={paginationObj?.page || 1}
                    activeListLength={reportList?.incident_reports?.data || []}
                    limit={REPORTING_LIMIT}
                    totalList={paginationObj?.total}
                    handlePagination={(e) => {
                      setPage(e);
                      const obj = paginationObj;
                      obj.page = e;
                      setPaginationObj({ ...obj });
                      fetchListReports(false, null, {
                        page: e,
                        sort_field: sortBy,
                        sort_order: sortDescending
                          ? SORT_TYPE.DESC
                          : SORT_TYPE.ASC,
                      });
                    }}
                    totalPages={paginationObj?.totalPages}
                  />
                </div>
              )}
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default IncidentReports;
